import { render, staticRenderFns } from "./SurveyStat.vue?vue&type=template&id=78701b86&scoped=true&"
import script from "./SurveyStat.vue?vue&type=script&lang=js&"
export * from "./SurveyStat.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStat.vue?vue&type=style&index=0&id=78701b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78701b86",
  null
  
)

export default component.exports